import React from 'react';
import { Sparkles } from 'lucide-react';

function Header() {
  return (
    <div className="text-center ">
      <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-3 py-1.5 rounded-full text-sm font-medium mb-4">
        <Sparkles className="w-4 h-4" />
        Choose Your Learning Journey
      </div>
      <h1 className="text-2xl lg:text-3xl font-bold bg-gradient-to-r from-primary via-primary/80 to-primary/60 bg-clip-text text-transparent mb-3">
        Choose Your Learning Journey
      </h1>
      <p className="text-sm text-muted-foreground max-w-xl mx-auto leading-relaxed">
        Unlock the power of AI-driven education with flexible plans designed to accelerate your learning
      </p>
    </div>
  );
}

export default Header;
